import { render, staticRenderFns } from "./editScoreScaleDevelopeds.vue?vue&type=template&id=dc351346&scoped=true"
import script from "./editScoreScaleDevelopeds.vue?vue&type=script&lang=js"
export * from "./editScoreScaleDevelopeds.vue?vue&type=script&lang=js"
import style0 from "./editScoreScaleDevelopeds.vue?vue&type=style&index=0&id=dc351346&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc351346",
  null
  
)

export default component.exports